import Reveal from "./Reveal";

export const SectionHead = ({ num, overline, title, desc }) => (
    <div className="mb-12 md:mb-16">
        <Reveal>
            <div className="flex items-center gap-4">
                <span className="font-mono text-xs tracking-[0.3em] text-safety">
                    {num}
                </span>
                <span className="h-px w-14 bg-safety/70" />
                <span className="font-mono text-[11px] uppercase tracking-[0.3em] text-zinc-400">
                    {overline}
                </span>
            </div>
        </Reveal>
        <Reveal delay={0.08}>
            <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl font-semibold uppercase tracking-tight leading-[1.02] mt-6 text-zinc-50">
                {title}
            </h2>
        </Reveal>
        {desc && (
            <Reveal delay={0.16}>
                <p className="mt-6 max-w-2xl text-zinc-400 leading-relaxed text-sm md:text-base">
                    {desc}
                </p>
            </Reveal>
        )}
    </div>
);

export default SectionHead;